<template>
  <div>
    <!-- <div class="flex-row" style="color:greenyellow">
      数量：{{ fileList.length }}
      <img height="48" width="auto" v-for="item in fileList" :src="item.url" />
    </div>
    <div class="flex-row" style="color:red">
      数量：{{ el.fileList.length }}
      <img height="48" width="auto" v-for="item in el.fileList" :src="item.url" />
    </div> -->
    <el-upload :style="`display:${el.hideStyle}`" :file-list="fileList" :action="upload.action" :headers="upload.headers"
      :on-preview="upload.handlePreview" :on-remove="upload.handleRemove" :multiple="el.multiple" :limit="el.limit"
      :on-exceed="upload.handleExceed" :before-upload="upload.beforeUpload" :on-success="upload.onSuccess"
      :on-error="upload.onError" :data="upload.formData" :list-type="listType" :show-file-list="showFileList" auto-upload
      :disabled="disabled" :accept="accept" :class="[el.hideStyle === 'unset'
        ? 'my-upload-video' : '', size === 'mini' ? 'my-upload-set-mini' : '']" :before-remove="upload.beforeRemove">
      <!-- <el-button size="small" type="primary">点击上传</el-button> -->
      <template #file="{ file }">
        <div class="picture-card"  v-if="listType.includes('video')">
          <div class="upload-video"  >
            <div class="video-card-mask">
              <div class="upload-video-delete">
                <i class="el-icon-delete" @click="upload.handleRemove(file)" />
              </div>
            </div>
            <video width="100%" height="100%" controls>
              <source :src="getUrl(file)" type="video/mp4" />
              您的浏览器不支持Video标签。
            </video>

          </div>
        </div>

      </template>
      <slot v-if="el.hideStyle === 'inline-block'">
        <i class="el-icon-plus"></i>
      </slot>
    </el-upload>
    <el-dialog :append-to-body="true" :visible.sync="preview.show">
      <img v-if="viewType === 1" width="100%" :src="preview.url" alt="" />
      <!-- <video v-if="viewType === 2" width="320" controls>
                <source :src="preview.url" type="video/mp4">
                您的浏览器不支持Video标签。
            </video> -->
    </el-dialog>
  </div>
</template>
<script>
import { OssUpload } from "@/class/upload";//调用后端接口上传至oss
import { InOssUpload } from "@/class/upload-oss.js"//前端直接调用oss接口上传
export default {
  props: {
    //text/picture/picture-card/picture-card video
    listType: {
      type: String,
      default: "picture-card",
    },
    //最大数量
    limit: {
      type: Number,
      default: 3,
    },
    //是否多选
    multiple: {
      type: Boolean,
      default: false,
    },
    //v-model
    value: {
      type: [String, Object, Array, undefined, null],
      default: undefined,
    },
    //当mode = string ,可以额外绑定一个:fileName.sync
    fileName: {
      type: String,
      default: undefined,
    },
    //object,array,string
    mode: {
      type: String,
      default: "string",
    },
    //是否禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    //是否显示文件
    showFileList: {
      type: Boolean,
      default: true,
    },
    //扩展名白名单
    accept: {
      type: String,
      default: ".png,.jpg,.jpeg,.docx,.doc,.xlsx,.xls,.pdf,.mp4,.zip,.rar,.ai,.7z",
    },
    //是否自动上传，当前为双向绑定，仅支持自动上传
    autoUpload: {
      type: Boolean,
      default: true,
    },
    //上传完成后，是否清禁fileList文件列表-通用于头像上传
    isClear: {
      type: Boolean,
      default: false,
    },
    //当model为object,array时，自定义的对象key.
    //{url:'testUrl',name:'testName'} {url:自定义的url-key，name:自定义的name-key}
    keyObject: {
      type: [Object, undefined],
      default: undefined,
    },
    //单个文件的大小，单位MB
    maxSize: {
      type: Number,
      default: 100,
    },
    //mini 尺寸
    size: {
      type: String,
      default: undefined,
    },
    //将数据转为JSON
    isJson: {
      type: Boolean,
      default: false,
    },
    //当前未用到
    isOss: {
      type: Boolean,
      default: false,
    },
    //保存路径的筒名
    modular: {
      type: String,
      default: 'Order'
    },
    //是否有删除提示
    isDelInfo: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    let upload = new InOssUpload();
    let { el } = upload;
    return {
      upload: upload, // { el: { fileList: [] } }, //watch的存在，需设置默认初始空值
      el: el,
      fileList: [],
      //预览
      preview: {
        url: "",
        show: false,
      },
      isInit: false,
      viewType: 1, //1:图片，2:mp4，3:其它
    };
  },
  watch: {
    //同步异步回显
    //当filelist为空时，即初始化前为空。
    //各种模式下进行回显。
    //已回显后，通过其它方式（非上传）更改v-model的值时，不会进行更变，如有需求，
    //请使用ref,修改filelist或修改后清空filelist
    value: {
      handler(newVal, old) {
        let val = newVal
        if (['array'].includes(this.mode) && newVal && this.isJson) {
          val = JSON.parse(newVal)
        }
        this.init();
        const { el } = this.upload;
        const length = this.el.fileList.length;
        if (val) {
          if (this.mode === "string") {
            if (val && length === 0) {
              this.upload.viewString(val, this.fileName);
              this.fileList = [...this.el.fileList]
            }
            if (!val && length > 0) {
              this.el.fileList = [];
              this.fileList = []
            }
          }
          if (this.mode === "object") {
            if (Object.keys(val).length > 0 && val && length === 0) {
              this.upload.viewObject(val);
              this.fileList = [...this.el.fileList]
            }
            if (Object.keys(val).length == 0 && length > 0) {
              this.el.fileList = [];
              this.fileList = []
            }
          }
          if (this.mode === "array") {
            if (val.length > 0) {
              this.el.fileList = [];
              this.upload.viewArray(val);
              this.fileList = [...this.el.fileList]
            }
            if (val.length === 0 && length > 0) {
              this.el.fileList = [];
              this.fileList = []
            }
          }
        } else {
          this.fileList = []
          this.el.fileList = []
          this.el.setStyleHide();
        }

      },
      deep: true,
      immediate: true,
    },
    disabled(val,old){
       this.el.disabled = val
       this.el.setStyleHide();
    }
  },
  methods: {
    sumEXT(url) {
      const idx = url.lastIndexOf(".");
      if (idx > -1) {
        let EXT = url.slice(idx).toLowerCase();
        //图片格式预览
        if ([".jpg", ".png", ".jpeg"].includes(EXT)) {
          return 1;
        }
        //mp4预览
        if ([".mp4"].includes(EXT)) {
          return 2;
        }
        //非图片及mp4格式，其它格式打开方式
        if (![".mp4", ".jpg", ".png", ".jpeg"].includes(EXT)) {
          return 3;
        }
      } else {
        return;
      }
    },
    //初始化upload
    init() {
      if (this.isInit) {
        return false;
      }
      const { el } = this.upload;
      el.multiple = this.multiple;
      el.limit = this.limit;
      el.mode = this.mode;
      el.keyObject = this.keyObject;
      el.isHide = this.isHide;
      el.accept = this.accept;
      el.maxSize = this.maxSize;
      el.fileName = this.fileName
      el.isDelInfo = this.isDelInfo
      el.disabled = this.disabled
      this.upload.modular = this.modular
      this.el.emit = () => {
        //上传成功
        console.log("---上传成功", el.successResult);
        this.$emit("onSuccess", el.successResult);
        if (this.isClear) {
          //上传成功后清除文件-适用于头像上传
          el.fileList = [];
        }
      };
      this.el.emitValue = () => {
        console.log('emitValue', el.fileMode)
        el.setStyleHide();
        const updateEmit = this.isJson ? JSON.stringify(el.fileMode) : el.fileMode
        this.$emit("update:fileName", el.fileName);
        this.$emit("input", updateEmit);
      };
      this.upload.removeFile = (url) => {
        for (let i in this.fileList) {
          let item = this.fileList[i];
          if (item.url === url) {
            this.fileList.splice(i, 1);
            break;
          }
        }
      }
      this.upload.updateFiles = () => {
        this.fileList = [...this.el.fileList]
      }
      this.upload.handlePreview = (uploadFile) => {
        console.log('handlePreview', uploadFile)
        //点击文件列表中已上传的文件时的钩子
        const data = uploadFile?.response?.data || uploadFile
        const url = data.filePath || data.url
        this.viewType = this.sumEXT(url);
        if (this.viewType === 1) {
          this.preview.url = url;
          this.preview.show = true;
        }
        if (this.viewType === 2) {
          this.preview.url = url;
          this.preview.show = true;
        }
        if (this.viewType === 3) {
          OssUpload.openUrl(url,data.name);
        }
      };
      //初始化完成后，阻止再次调用
      this.isInit = true;
    },
    getUrl(uploadFile) {
      const data = uploadFile?.response?.data || uploadFile
      const url = data.filePath || data.url
      return url
    },
    getEXT(uploadFile) {
      const data = uploadFile?.response?.data || uploadFile
      const url = data.filePath || data.url
      let idx = url.lastIndexOf(".");
      if (idx > -1) {
        let EXT = url.slice(idx).toLowerCase();
        return EXT
      } else {
        return false
      }
    }
  },
};
</script>
<style lang="less" scoped>
::v-deep(.el-upload) {
  display: inherit !important;
}





::v-deep(.my-upload-video) {
  .el-upload--picture-card {
    border: none;
  }
}

::v-deep(.my-upload-set-mini) {
  .el-upload-list--picture-card .el-upload-list__item {
    width: 64px;
    height: 64px;
  }

  .el-upload--picture-card {
    width: 64px;
    height: 64px;
    line-height: 74px;
  }

  .el-upload-list--text {
    width: auto;
  }

  .el-upload-list__item {
    width: 120px;

    .el-upload-list__item-name {
      width: 100px;
    }
  }

}


::v-deep(.el-upload-list--text) {
  width: 300px;
}

// ::v-deep(.el-upload--picture-card) {
//     width: 100px !important;
//     height: 100px !important;
//     line-height: 110px !important;
// }

// ::v-deep(.el-upload-list--picture-card) {
//     width: 100px !important;
//     height: 100px !important;
//     line-height: 110px !important;
// }
.picture-card {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  .picture-card-success {
    position: absolute;
    height: 40px;
    width: 40px;
    background: rgb(7, 228, 117);
    right: -20px;
    top: -20px;
    transform: rotate(45deg);
    z-index: 100;

    i {
      transform: rotate(-45deg);
      color: white;
      font-size: 16px;
      line-height: 76px;
      text-align: left;
      padding-left: 14px;
    }
  }

  &:hover .picture-card-mask {
    display: flex;
  }

  .picture-card-mask,
  .video-card-mask {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100;
    background: rgba(0, 0, 0, 0.2);
    display: none;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .upload-card-view {
      margin-right: 10px;
      cursor: pointer;

      i {
        color: white;
        font-size: 20px;
      }
    }

    .upload-card-delete {
      margin-left: 10px;
      cursor: pointer;

      i {
        color: white;
        font-size: 20px;
      }
    }
  }

  .upload-video {
  height: 148px;
  width: 148px;
  position: relative;

  &:hover .video-card-mask {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50% !important;
  }
}
.upload-video-delete {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  i {
    cursor: pointer;
    font-size:20px;
    color: white;
  }
}

}
</style>
